import { render, staticRenderFns } from "./YagifriendsPageLoader.vue?vue&type=template&id=022615f0&scoped=true"
import script from "./YagifriendsPageLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./YagifriendsPageLoader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./YagifriendsPageLoader.vue?vue&type=style&index=0&id=022615f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022615f0",
  null
  
)

export default component.exports